import React, { useRef } from 'react'
import { Container } from 'src/components/common/Container'
import styled, { css } from 'styled-components'
import { GiftReceiveResultPageProps } from 'src/pages/GiftCardPage/GiftReceiveResultPage/index'
import GiftResultMsgCard from 'src/pages/GiftCardPage/GiftReceiveResultPage/_components/GiftResultMsgCard'
import RenderIf from 'src/components/common/RenderIf'
import { CouponDetailCard } from 'src/components/common/CouponDetailCardItems'
import Skeleton from 'react-loading-skeleton'
import { Divider } from 'src/components/common/Divider'
import PurchaseHistoryDetailUnderLineTab from 'src/pages/PurchaseHistoryPage/PurchaseHistoryDetailPage/_components/PurchaseHistoryDetailUnderLineTab'
import Button, { ButtonOption1, ButtonOption3 } from 'src/components/common/Button'
import GiftResultHotDeal from 'src/pages/GiftCardPage/GiftReceiveResultPage/_components/GiftResultHotDeal'
import usePageNav from 'src/hooks/usePageNav.hook'
import LazyImage from 'src/components/common/LazyImage'
import { Noto_body2_m14 } from 'src/styles/fonts/NotoSansKrFonts'
import GiftHeader from 'src/components/layout/GiftHeader/view'
import useParamsType from 'src/hooks/useParamsType.hook'
import { GiftType } from 'src/types/api'
import Footer from 'src/components/layout/Footer'
import { layoutMaxSize } from 'src/styles/mixin'

const GiftReceiveResultPageView = (props: GiftReceiveResultPageProps) => {
  const { conponInfoList, bannerItem, giftDetailData, contentsStatus } = props
  const { giftHotDealPageNav, giftRefundApplyPageNav } = usePageNav()
  const { requestId, giftType } = useParamsType()
  const detailTabRef = useRef<HTMLDivElement>(null)
  const { GiftIdx } = giftDetailData
  const {
    couponInfo: isShowCouponInfo,
    refundBtn: isShowRefundBtn,
    sendTooBtn: isShowSendTooBtn,
  } = contentsStatus

  const scrollToDetailTab = () => {
    if (detailTabRef.current) {
      detailTabRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <S.Background>
      <S.GiftReceiveResultWrap $option="flex_column">
        <GiftHeader isLogoTitle={true} />
        {/*쿠폰 및 메시지*/}
        <GiftResultMsgCard {...props} />
        {/*선물 정보*/}
        <RenderIf when={isShowCouponInfo}>
          <S.GiftCardDetailContainer>
            <CouponDetailCard.DetailInfoList>
              {conponInfoList?.map((ele, index: number) => (
                <RenderIf when={!!ele?.label} key={index}>
                  <CouponDetailCard.DetailInfoLine
                    key={index}
                    $disabled={!ele}
                    as={ele?.value?.[0]?.text !== '' || !!ele?.value ? 'div' : Skeleton}
                  >
                    <CouponDetailCard.DetailTitle>{ele?.label}</CouponDetailCard.DetailTitle>
                    <span>
                      {ele?.value?.map((value, index) => (
                        <CouponDetailCard.DetailDesc
                          $bold={value?.bold}
                          $color={value?.color}
                          key={index}
                        >
                          {' '}
                          {value?.text}
                        </CouponDetailCard.DetailDesc>
                      ))}
                    </span>
                  </CouponDetailCard.DetailInfoLine>
                </RenderIf>
              ))}
            </CouponDetailCard.DetailInfoList>
            <S.GiftCardMoveScrollBtnWrap $option="flex_column" $row_gap="10px">
              {/*스크롤 이동*/}
              <Button option={ButtonOption1('default')} onClickFn={scrollToDetailTab}>
                이용안내 확인
              </Button>
              {/*환불하기*/}
              <RenderIf when={isShowRefundBtn}>
                <S.GiftRefundBtn
                  onClick={() =>
                    giftRefundApplyPageNav(requestId, Number(giftType) as GiftType, GiftIdx)
                  }
                >
                  환불하기
                </S.GiftRefundBtn>
              </RenderIf>
            </S.GiftCardMoveScrollBtnWrap>
          </S.GiftCardDetailContainer>
          <Divider />
        </RenderIf>
        {/*핫딜*/}
        <GiftResultHotDeal {...props} />
        {/*배너*/}
        <LazyImage
          src={bannerItem?.Image}
          alt="배너 이미지"
          style={S.GiftCardBanner()}
          onClick={() => window.open(bannerItem?.URL, '_blank')}
        />
        {/*이용안내 및 상세정보*/}
        <RenderIf when={isShowCouponInfo}>
          <Divider />
          <div ref={detailTabRef} />
          <PurchaseHistoryDetailUnderLineTab {...props} />
        </RenderIf>
        <Footer />
        {/*하단 고정 버튼*/}
        <RenderIf when={isShowSendTooBtn}>
          <S.GiftCardBottomContainer $option="flex_column">
            <Button option={ButtonOption3('active')} onClickFn={giftHotDealPageNav}>
              나도 선물하기
            </Button>
          </S.GiftCardBottomContainer>
        </RenderIf>
      </S.GiftReceiveResultWrap>
    </S.Background>
  )
}
export default GiftReceiveResultPageView

const S = {
  Background: styled(Container)`
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: var(--black-2);
  `,
  GiftReceiveResultWrap: styled(Container)`
    ${layoutMaxSize};
    margin-top: 50px;
    align-items: center;
    background-color: var(--white);
    min-width: 320px;
  `,
  GiftCardBanner: () => css``,
  GiftCardDetailContainer: styled(Container)`
    max-width: 360px;
    width: 100%;
  `,
  GiftCardMoveScrollBtnWrap: styled(Container)`
    padding: 0 20px 20px 20px;
    align-items: center;
  `,
  GiftRefundBtn: styled.button`
    ${Noto_body2_m14};
    padding: 3px 10px;
    width: 72px;
    color: var(--black-30);
  `,
  GiftCardBottomContainer: styled(Container)`
    ${layoutMaxSize};
    min-width: 320px;
    width: 100%;
    padding: 10px;
    position: fixed;
    bottom: 0;
    background-color: var(--white);
    z-index: 2;
  `,
}
